import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { TextField, Button, Container, Typography, Paper, Grid } from '@mui/material';
import ApiService from '../../Api/ApiController';
import Swal from 'sweetalert2';

export default function SendNotification() {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await ApiService.userlistForcreateOrder();
        if (response.data.status) {
          const formattedUsers = response.data.data.map(user => ({
            value: user._id,
            label: user.name,
          }));
          setUsers(formattedUsers);
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchUsers();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ title, description, user_ids: selectedUsers.map(user => user.value) });
    ApiService.createNotification({
      title,
      description,
      user_ids:selectedUsers.map(user => user.value)
    }).then((response)=>{
        if(response.data.status === true){
          Swal.fire({
            toast: true,
            position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 3000, // Duration in milliseconds
            timerProgressBar: true,
          });
          setDescription('');
          setTitle('');
          setSelectedUsers([])

        }else{
            Swal.fire({
              toast: true,
              position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
              icon: 'error',
              title: response.data.message,
              showConfirmButton: false,
              timer: 3000, // Duration in milliseconds
              timerProgressBar: true,
            });
        }
    }).catch((error)=>{
       Swal.fire({
              toast: true,
              position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
              icon: 'error',
              title:error.response.data.message,
              showConfirmButton: false,
              timer: 3000, // Duration in milliseconds
              timerProgressBar: true,
            });
    })
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} style={{ padding: 20, marginTop: 20 }}>
        <Typography variant="h5" gutterBottom>
          Send Notification
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Title"
                variant="outlined"
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                isMulti
                options={users}
                value={selectedUsers}
                onChange={setSelectedUsers}
                placeholder="Search and select users..."
                classNamePrefix="react-select"
              />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary" fullWidth>
                Send Notification
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
}
